import dayjs from 'dayjs'

export function toTimeString(timestamp: number) {
  return dayjs(timestamp * 1000).format('HH:mm DD-MM-YYYY')
}
